import { actions } from './hospitalization_final_conclusions/actions'
import { getters } from './hospitalization_final_conclusions/getters'
import { state } from './hospitalization_final_conclusions/state'
import { mutations } from './hospitalization_final_conclusions/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
